import React, { Component } from 'react';
import { List, Segment, Icon, Grid } from 'semantic-ui-react';

export default class LeftMenu extends Component {
  render() {
    return (
      <Segment className="px0 br0" inverted>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <List inverted divided relaxed style={{ height: '100%' }}>
                <List.Item>
                  <List.Content>
                    <Segment textAlign="center" inverted size="mini">
                      <Icon name="box" size="big" />
                      <div>Template</div>
                    </Segment>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <Segment textAlign="center" inverted size="mini">
                      <Icon.Group size="big">
                        <Icon name="circle" />
                        <Icon corner name="square" />
                      </Icon.Group>
                      <div>Shapes</div>
                    </Segment>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <Segment textAlign="center" inverted size="mini">
                      <Icon name="image" size="big" />
                      <div>Images</div>
                    </Segment>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>
            {this.props.selected_menu ? (
              <Grid.Column>
                <Segment>asdf</Segment>
              </Grid.Column>
            ) : (
              ''
            )}
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}
